import type { UnwrapNestedRefs } from "vue";
import indexOf from "lodash-es/indexOf";
import isUndefined from "lodash-es/isUndefined";
import findIndex from "lodash-es/findIndex";
import cloneDeep from "lodash-es/cloneDeep";
import isFunction from "lodash-es/isFunction";
import isEqual from "lodash-es/isEqual";
import isArray from "lodash-es/isArray";
import { ElButton, ElRow, ElCol, ElForm, ElFormItem, ElMessage, } from "element-plus";
import { buildProps } from "../../utils/props";
import { memberComponents } from "./config";
import submitToServerFunc, { submitToSeverProps, } from "../../commonMix/submitToServer";
import "./style.scss";
import { defineComponent, onMounted, watch } from "vue";
import type { ComponentPublicInstance, ExtractPropTypes, PropType, SetupContext, StyleValue, VNode } from "vue";
import type { SubmitToSeverOperateType } from "../../commonMix/submitToServer/types";
import type { ButtonGroupRenderInterface, ElFormPropsType, FormDataStateType, FormItemContentRenderInterface, FormRenderItemConfType, MemberComponentType, QuickFormType, QuickFormUserRenderInterface, RenderDataFilterType, RenderNodesType, ResetFormInterface, SubmitFormInterface, ValidateInterface, OnSubmitInterface } from "./types";
import { reactive } from "vue";
import useRender from "./useRender";
import type { ComponentSize } from "element-plus";

const defaultGroup: FormRenderItemConfType<any> = {
  type: "group",
  
  children: [],
};
export const QuickFormProps = {
  ...submitToSeverProps,
  ...buildProps({
    resetBtnToClear: {
      type: Boolean,
      default: true,
    }, // true 重置按钮直接清除数据，false则为恢复初始数据
    formRefObj: {
      // 获取内部el-form的实例
      type: [Boolean, Object, Function],
      default: false,
    },
    mountedHandler: {
      // 渲染完成时的回调
      type: [Function, Boolean],
      default: false,
    },
    isSlotRender: {
      // 是否支持从slot渲染表单，使用 scopedSlots 获取 submitForm FormValue
      type: Boolean,
      default: false,
    },
    renderData: {
      // 表单项的渲染配置
      type: Array as PropType<FormRenderItemConfType<any>[]>,
      default: () => [],
    },
    renderDataFilter: {
      // 表单项的渲染配置过滤·方法
      type: Function as PropType<RenderDataFilterType>,
      default: (
        res: FormRenderItemConfType<any>[]
      ): FormRenderItemConfType<any>[] => res,
    },
    // 设置Form的props
    formProps: {
      type: Object as PropType<Partial<ElFormPropsType>>,
      default: () => ({}),
    },
    onlyFormItem:{  // 是否成员项只渲染对应组件和formitem,否则会渲染带上ElCol包装
      type: Boolean,
      default:false,
    },
    formSize: {
      type: String as PropType<ComponentSize>,
    },
    disabled: {
      type: Boolean,
      default: false,
    }, // 设置表单项的disabled
    // 设置Form的modelValue
    modelValue: {
      type: Object,
      default: () => ({}),
    },

    // 设置Form的group基础数据
    baseGroupConf: {
      type: Object,
      default: (): FormRenderItemConfType<any> => defaultGroup,
    },
    onSubmit: {
      // 当表单提交时的回调 ，也可以直接监听 submit
      type: [Boolean,Function as PropType<OnSubmitInterface>],
      default:false,
    },
    afterValueChange: {
      // 当表单值改变时候的回调 ，也可以直接监听value-change
      type: Function,
      default: () => {},
    },
    // 设置btnGroup的col属性设置
    buttonGroupColConfig: {
      // 表单项按钮组 el—col 的配置
      type: [Object, Boolean],
      default: () => ({
        span: 24,
        style: {
          "text-align": "center",
        },
      }),
    },
    buttonGroupRender: {
      // 表单项按钮组的渲染函数
      type: Function as PropType<ButtonGroupRenderInterface>,
      default:  (
        modelValue: any,
        submitFunc: SubmitFormInterface,
        resetFunc: ResetFormInterface,
        validate: ValidateInterface,
        formDataState: UnwrapNestedRefs<FormDataStateType>,
        submitMixResult: SubmitToSeverOperateType,
        props: any
      ): RenderNodesType => {
        return [
          <ElButton
            type="primary"
            loading={!!submitMixResult.loading.value}
            size={props.formSize}
            onClick={submitFunc}
          >
            提交
          </ElButton>,
          <ElButton size={props.formSize} onClick={resetFunc}>
            重置
          </ElButton>,
        ];
      },
    },
    formItemContentRender: {
      // 表单项formItem的渲染函数返回props
      type: Function as PropType<FormItemContentRenderInterface>,
      default: (
        result: RenderNodesType,
        itemConf: FormRenderItemConfType<any>,
        formValue: any
      ) => {
        return result;
      },
    },
    fieldStyle: {
      // 表单项formItem的style ,也可以单独给每一项设置fieldStyle
      type: [Object as PropType<StyleValue>, String],
      default: () => ({}),
    },
    fieldContentStyle: {
      // 表单项formItem的对应表单项style ,也可以单独给每一项设置style
      type: [Object as PropType<StyleValue>, String],
      default: () => ({}),
    },
    propsData: {
      // 用来存储数据，无其他用处
      type: [Object],
      default: () => ({}),
    },
    notCloneDeepModelValue:{
      type:Boolean,
      default:false
    }
  }),
};

export type QuickFormPropsType = ExtractPropTypes<typeof QuickFormProps>;
export function addQuickFormMemberComponents(item:MemberComponentType):void{
  memberComponents.push(item)
}
export default defineComponent({
  
  name: "QuickForm",
  components: {
    ElRow,
    ElCol,
    ElFormItem,
    ElForm,
  },
  /**
   * 设置formvalue
   */
  // emits: ["submit", "error", "update:modelValue", "mountedHandler","submitSuccess"],
  setup(props: QuickFormPropsType, ctx: SetupContext<any>): QuickFormType {
    const formRefs: any = {};
    const getFormRef = (el: any) => {
      formRefs.elForm = el;
    };
    const initResetValueMap:any={

    }
    const formDataState: UnwrapNestedRefs<FormDataStateType> = reactive({
      formValue: !props.notCloneDeepModelValue ? cloneDeep(props.modelValue) : props.modelValue,
      valueFormulaMap: {},
    });

    const submitMixResult: SubmitToSeverOperateType = submitToServerFunc(
      props,
      ctx,
      {
        /**
         * 列表调用成功后的回调
         * @param {Object} 返回的值 //
         */
        afterSuccessFunc: (res: any) => {
          console.log("success", res);
        },
        /**
         * 列表调用失败后的回调
         * @param {Error} 返回的错误信息 //
         */
        afterErrorFunc: (err: any) => {
          ElMessage({
            message: err.message ? err.message + "" : err + "",
            type: "error",
          });
        },
      }
    );
    const quickFormUseRender: QuickFormUserRenderInterface = useRender(
      props,
      ctx,
      formDataState,
      formRefs,
      submitForm,
      resetForm,
      submitSlotForm,
      submitMixResult,
      initResetValueMap
    );
    watch(
      () => formDataState.formValue,
      (newVal) => {
        ctx.emit("update:modelValue", newVal);
      }
    );
    watch(
      () => props.modelValue,
      (newVal) => {
        if(formDataState.formValue!=newVal) formDataState.formValue = newVal;
      }
    );

    onMounted(() => {
      ctx.emit("mountedHandler", ctx);
      if (isFunction(props.mountedHandler)) props.mountedHandler(ctx);
    });

    function submitForm(mergeData:any = {}, isValid:boolean = true):void {
      if (!isValid) {
        validSuccessAfterFunc(mergeData);
        return;
      }
      formRefs.elForm &&
        formRefs.elForm.validate((valid: boolean) => {
          if (valid) {
            validSuccessAfterFunc(mergeData);
          } else {
            console.log("error submit!!");
            return false;
          }
        });
    }
    function getFormRefObj(formRefObj: any):any{
      return quickFormUseRender.formRef?quickFormUseRender.formRef.entity:null;
    }
    function submitSlotForm(mergeData: any = {}, formRefObj: any) {
      // 从template里的el-form提交参数
      const formObj =
        formRefObj || getFormRefObj(formRefObj)  
      if (!formObj) {
        validSuccessAfterFunc(mergeData);
        return;
      }
      formObj.validate((valid: boolean) => {
        if (valid) {
          validSuccessAfterFunc(mergeData);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
 
    function validSuccessAfterFunc(mergeData: any):void {
      let setVal = cloneDeep(formDataState.formValue);
      setVal = Object.assign(setVal, mergeData);
      if( isFunction(props.onSubmit)){
        props.onSubmit(setVal);
      }
      if(!isFunction(props.onSubmit)){
        ctx.emit("submit", setVal);
      }
      if (props.url||props.fetchApi) {
        // 加入有url，然后提交url数据
        const newFetchData: any = cloneDeep(props.fetchData);
        submitMixResult.goFetchFunc({ ...setVal, ...newFetchData });
      }
    }

    function resetForm():void {
      if (!props.resetBtnToClear) {
        const setData:any={};
   
        Object.keys(initResetValueMap).map((key:string)=>{
          setData[key]= cloneDeep(initResetValueMap[key]);
        })
        formDataState.formValue = setData;
      } else {
        formRefs.elForm&& formRefs.elForm.resetFields();

        Object.keys(initResetValueMap).map((key:string)=>{
          formDataState.formValue[key]= cloneDeep(initResetValueMap[key]);
        })
    
      }
    }

    return {
      ...quickFormUseRender,
      ...submitMixResult,
      resetForm,
      formDataState,
      submitForm,
      submitSlotForm,
      formRefs,
      getFormRef,
    };
  },

  props: QuickFormProps,

  render(_ctx: ComponentPublicInstance<QuickFormPropsType,QuickFormType>   ): RenderNodesType {
    return _ctx.elFormRender();
  },
});
